import { render, staticRenderFns } from "./layout-detail.vue?vue&type=template&id=5a44e394&scoped=true&"
import script from "./layout-detail.vue?vue&type=script&lang=js&"
export * from "./layout-detail.vue?vue&type=script&lang=js&"
import style0 from "./layout-detail.vue?vue&type=style&index=0&id=5a44e394&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a44e394",
  null
  
)

export default component.exports